import { api } from './api';
import { getTenant } from '../helpers';

export function getUserCredentialsAPI(username: string, callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdcredapi.credentialsOrgsUsersAssertionsRetrieve(...args),
    getTenant(),
    username,
    username,
  )((err, data, response) => callback(response?.body[0]?.data));
}

export function getDiscoverCredentialsAPI(username: string,  callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdcredapi.credentialsOrgsUsersRetrieve(...args),
    getTenant(),
    username,
  )((err, data, response) => callback(response?.body?.result?.data));
}
